import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

export class UpsertDevExpressReportSettings<T extends EMode = EMode.entity> {
  /** Alias: setLogo1 */
  setLogo1?: any;
  /** Alias: setLogo2 */
  setLogo2?: any;
  /** Alias: setAddressLineOverride */
  setAddressLineOverride?: string;
  /** Alias: setFooterHtml */
  setFooterHtml?: string;
  /** Alias: logo1PosX */
  logo1PosX?: number;
  /** Alias: logo1PosY */
  logo1PosY?: number;
  /** Alias: logo2PosX */
  logo2PosX?: number;
  /** Alias: logo2PosY */
  logo2PosY?: number;

  __typename?: string;
}

const fields: FieldDefinitions<UpsertDevExpressReportSettings> = {
  setLogo1: {
    alias: 'setLogo1',
  },
  setLogo2: {
    alias: 'setLogo2',
  },
  setAddressLineOverride: {
    alias: 'setAddressLineOverride',
  },
  setFooterHtml: {
    alias: 'setFooterHtml',
  },
  logo1PosX: {
    alias: 'logo1PosX',
  },
  logo1PosY: {
    alias: 'logo1PosY',
  },
  logo2PosX: {
    alias: 'logo2PosX',
  },
  logo2PosY: {
    alias: 'logo2PosY',
  },
  __typename: {
    alias: '__typename',
  },
};

export const upsertDevExpressReportSettingsEntityDefinition: EntitiyDefinition<UpsertDevExpressReportSettings> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'UpsertDevExpressReportSettings',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
